import React from 'react'

interface IcSensitivityProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcSensitivity: React.FC<IcSensitivityProps> = ({
  width = '16px',
  height = '16px',
  color = '#666666',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        d="M2.39999 15.2V10.88C2.39999 10.484 2.54099 10.145 2.82299 9.863C3.10499 9.581 3.44399 9.44 3.83999 9.44H12.48C12.876 9.44 13.215 9.581 13.497 9.863C13.779 10.145 13.92 10.484 13.92 10.88V15.2H2.39999ZM3.83999 12.32H12.48V10.88H3.83999V12.32ZM8.15999 9.44L4.55999 4.4C4.55999 3.404 4.91099 2.555 5.61299 1.853C6.31499 1.151 7.16399 0.800003 8.15999 0.800003C9.15599 0.800003 10.005 1.151 10.707 1.853C11.409 2.555 11.76 3.404 11.76 4.4L8.15999 9.44ZM8.15999 7.424L10.32 4.4C10.32 3.8 10.11 3.29 9.68999 2.87C9.26999 2.45 8.75999 2.24 8.15999 2.24C7.55999 2.24 7.04999 2.45 6.62999 2.87C6.20999 3.29 5.99999 3.8 5.99999 4.4L8.15999 7.424Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IcSensitivity
